import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { STATUS_CONFIG, QUALIFICATION_CONFIG, formatDateShort } from '../utils/constants';
import { Star, Trash2 } from 'lucide-react';
import api from '../utils/api';
import LeadDetail from './LeadDetail';

export default function LeadTable({ leads, onRefresh, showDatasetCol, total, page, pages, filters, setFilters, datasets }) {
  const { tenant } = useAuth();
  const [selectedLead, setSelectedLead] = useState(null);
  const customCols = tenant?.features?.custom_columns || [];

  const getExtraField = (lead, key) => {
    if (!lead.extra_data) return '—';
    try {
      const data = typeof lead.extra_data === 'string' ? JSON.parse(lead.extra_data) : lead.extra_data;
      return data[key] || '—';
    } catch { return '—'; }
  };

  const openLead = async (lead) => {
    try {
      const res = await api.get('/leads/' + lead.id);
      setSelectedLead(res.data);
    } catch {}
  };

  return (
    <>
      {filters && setFilters && (
        <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
          <input placeholder="Buscar..." value={filters.search||''} onChange={e => setFilters({...filters, search: e.target.value, page:1})} style={{ maxWidth:200 }} />
          <select value={filters.status||''} onChange={e => setFilters({...filters, status: e.target.value, page:1})}>
            <option value="">Todos los estados</option>
            {Object.entries(STATUS_CONFIG).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
          <select value={filters.qualification||''} onChange={e => setFilters({...filters, qualification: e.target.value, page:1})}>
            <option value="">Todas las calificaciones</option>
            {Object.entries(QUALIFICATION_CONFIG).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
          {(filters.search || filters.status || filters.qualification) && <button className="btn btn-ghost btn-sm" onClick={() => setFilters({...filters, search:'', status:'', qualification:'', page:1})}>Limpiar</button>}
        </div>
      )}

      <div className="table-container">
        <table>
          <thead><tr>
            <th style={{width:30}}></th>
            <th>Negocio</th>
            <th>Teléfono</th>
            <th>Ciudad</th>
            <th>Sector</th>
            {showDatasetCol && <th>Base</th>}
            <th>Fuente</th>
            <th>UTM Source</th>
            <th>Campaña</th>
            <th>Estado</th>
            <th>Calificación</th>
            {customCols.map(c => <th key={c.key}>{c.label}</th>)}
            <th>Ingreso</th>
            <th>Último contacto</th>
            <th style={{width:40}}></th>
          </tr></thead>
          <tbody>
            {leads.length === 0 ? (
              <tr><td colSpan={14 + (showDatasetCol?1:0) + customCols.length} style={{ textAlign:'center', padding:40, color:'var(--text-muted)' }}>No se encontraron leads</td></tr>
            ) : leads.map(lead => {
              const sc = STATUS_CONFIG[lead.status] || {};
              const qc = QUALIFICATION_CONFIG[lead.qualification] || {};
              return (
                <tr key={lead.id} onClick={() => openLead(lead)} style={{ cursor:'pointer', background: selectedLead?.id === lead.id ? 'var(--accent-glow)' : 'transparent' }}>
                  <td onClick={e => { e.stopPropagation(); api.put('/leads/'+lead.id+'/favorite').then(onRefresh); }}>
                    <Star size={14} fill={lead.is_favorite ? '#eab308' : 'none'} color={lead.is_favorite ? '#eab308' : 'var(--text-muted)'} style={{cursor:'pointer'}}/>
                  </td>
                  <td style={{ fontWeight:600, maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.business_name || '—'}</td>
                  <td style={{ fontSize:13 }}>{lead.phone || '—'}</td>
                  <td style={{ fontSize:12, color:'var(--text-secondary)' }}>{lead.city || '—'}</td>
                  <td style={{ fontSize:12, color:'var(--text-secondary)' }}>{lead.category || '—'}</td>
                  {showDatasetCol && <td style={{ fontSize:12, color:'var(--text-muted)' }}>{lead.dataset_name || '—'}</td>}
                  <td><span className="badge" style={{ fontSize:10, background:'rgba(46,125,226,0.12)', color:'var(--accent)' }}>{lead.source || '—'}</span></td>
                  <td style={{ fontSize:11, color:'var(--text-muted)' }}>{lead.utm_source || '—'}</td>
                  <td style={{ fontSize:11, color:'var(--text-muted)', maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.utm_campaign || '—'}</td>
                  <td><span className="badge" style={{ background: sc.bg || 'rgba(100,116,139,0.15)', color: sc.color || '#64748b', fontSize:11 }}>{sc.label || lead.status}</span></td>
                  <td><span className="badge" style={{ background: qc.bg || 'rgba(100,116,139,0.15)', color: qc.color || '#64748b', fontSize:11 }}>{qc.label || lead.qualification}</span></td>
                  {customCols.map(c => <td key={c.key} style={{ fontSize:12, color:'var(--text-secondary)' }}>{getExtraField(lead, c.key)}</td>)}
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{formatDateShort(lead.created_at)}</td>
                  <td><input type="date" value={lead.last_contacted_at ? lead.last_contacted_at.split('T')[0] : ''} onChange={async e => { e.stopPropagation(); try { await api.put('/leads/'+lead.id+'/last-contact', { date: e.target.value }); onRefresh(); } catch {} }} onClick={e => e.stopPropagation()} style={{ background:'transparent', border:'1px solid var(--border)', borderRadius:6, padding:'2px 6px', fontSize:11, color:'var(--text-secondary)', width:120, cursor:'pointer' }} /></td>
                  <td><button className="btn btn-ghost btn-sm" onClick={e => { e.stopPropagation(); if(window.confirm('¿Eliminar?')) api.delete('/leads/'+lead.id).then(onRefresh); }} style={{ color:'var(--danger)', padding:4 }}><Trash2 size={14}/></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {pages > 1 && (
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:16 }}>
          <button className="btn btn-secondary btn-sm" disabled={page<=1} onClick={() => setFilters({...filters, page: page-1})}>Anterior</button>
          <span style={{ color:'var(--text-muted)', fontSize:13, padding:'6px 12px' }}>Página {page} de {pages} ({total} leads)</span>
          <button className="btn btn-secondary btn-sm" disabled={page>=pages} onClick={() => setFilters({...filters, page: page+1})}>Siguiente</button>
        </div>
      )}

      {selectedLead && (
        <LeadDetail lead={selectedLead} onClose={() => setSelectedLead(null)} onRefresh={() => { onRefresh(); if(selectedLead) openLead(selectedLead); }} />
      )}
    </>
  );
}
